module.exports = __webpack_public_path__ + "static/media/poneover.6724a4e8.png";